import Axios from 'axios';

export class InfosApi {
  static getVersion ():Promise<string> {
    return Axios.get('/public/infos/version').then(response => response.data);
  }
}
